<app-loader></app-loader>
<ng-container *ngIf="this.translationsLoaded">
  <router-outlet></router-outlet>
</ng-container>
